<template>
  <component :is="layoutComponent">
    <router-view />
  </component>
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'

import LayoutDefault from '@/layouts/LayoutDefault.vue'
import LayoutCheckout from '@/layouts/LayoutCheckout.vue'
import AuthLayout from '@/layouts/AuthLayout.vue'
import LayoutAdmin from '@/layouts/LayoutAdmin.vue'
import LayoutEventPage from '@/layouts/LayoutEventPage.vue'

const route = useRoute()

const layoutComponent = computed(() => {
  const layout = route.meta.layout
  if (layout === 'checkout') return LayoutCheckout;
  if (layout === 'auth') return AuthLayout;
  if (layout === 'admin') return LayoutAdmin;
  if (layout === 'event-page') return LayoutEventPage;
  return LayoutDefault
})
</script>